<template>
  <UIDialogActions
    :is-open
    :actions
    :z-index
    title="You have an unsaved value"
    @close="handleClose"
  >
    <span class="text-base sm:text-sm">You can click "Cancel" and continue editing or skip and lose the data.</span>
  </UIDialogActions>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { DialogActionsButton, ModalClass } from '@types'

import { UIDialogActions } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
}

type Emits = {
  confirm: []
  cancel: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const zIndex = computed(() => props.modal.zIndex)
const isOpen = computed(() => props.modal.isOpened)

const actions = computed<DialogActionsButton[]>(() => [
  {
    label: 'Skip and lose data',
    onClick: handleConfirm,
    buttonVariant: 'danger',
  },
])

const handleClose = () => {
  props.modal.close()
  emit('cancel')
}

const handleConfirm = () => {
  props.modal.close()
  emit('confirm')
}
</script>
